// Chọn summary cho dòng đơn nâng cấp chưa có summaryId (dùng khi gửi FinishUpgradeV2)
// hint: summary mà dòng được tạo từ đó. Đổi sang SP khác (VD SIM Viettel -> gói cước) vẫn giữ summary này,
// để KD thấy KT đã đổi và duyệt. Hint chỉ nhận khi cùng xe + công ty và còn sức chứa cho mã SP mới.
// Không có hint hợp lệ: tìm summary đúng SP (cùng mã hoặc bộ chứa SP). Không khớp -> undefined (SP KT thêm).
// VD: hint = summary 34047 (Viettel 4G, quantity 1), đổi sang SP0140 -> trả 34047 (chưa dùng cho SP0140)
export const pickUpgradeSummary = ({
  summaries,
  hintId,
  registrationPlate,
  companyId,
  maSP,
  canHold,
  hasRoom
}: {
  summaries: any[];
  hintId: any;
  registrationPlate: string;
  companyId: number;
  maSP: string;
  canHold: (summary: any, maSP: string) => boolean;
  hasRoom: (summary: any, maSP: string) => boolean;
}) => {
  const sameVehicle = (s: any) => s.registrationPlate === registrationPlate && s.companyId === companyId;

  const hint = summaries.find(s => s.id === hintId && sameVehicle(s) && hasRoom(s, maSP));
  if (hint) return hint;

  const pool = summaries.filter(s => sameVehicle(s) && canHold(s, maSP) && hasRoom(s, maSP));
  return pool.find(s => s.maSanPhamMoi === maSP) || pool[0];
};
